module.exports = __webpack_public_path__ + "img/menu_icon14.1bc1a43b.png";